import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';
import styles from 'src/containers/AutopromoContentContainer.scss';
import AutopromoContent from 'src/components/AutopromoContent';


const AutopromoContentContainer = ({
  containerAlign,
  isCenterAlign,
  darkFontVersion,
  titleMobile,
  subtitleMobile,
  buttonsMobile,
  title,
  subtitle,
  buttons,
  isCenterAlignDesktop
}) => (
  <div className={ classNames({
    [styles['content-container']]: true,
    [styles[`content-container--${containerAlign}`]]: true,
    [styles['content-container--light']]: darkFontVersion
  }) }
  >
    <div className={ classNames({
      [styles['autopromo-content']]: true,
      [styles['autopromo-content--centerAlign']]: isCenterAlign,
      [styles['autopromo-content--light']]: containerAlign === 'center',
      [styles['autopromo-content--center']]: containerAlign === 'center'
    }) }
    >
      <AutopromoContent
        buttons={ buttonsMobile }
        containerAlign={ containerAlign }
        subtitle={ subtitleMobile }
        title={ titleMobile }
      />
    </div>
    <div className={ classNames({
      [styles['autopromo-content--desktop']]: true,
      [styles['autopromo-content--centerAlign']]: isCenterAlignDesktop,
      [styles['autopromo-content--center']]: containerAlign === 'center'
    }) }
    >
      <AutopromoContent
        buttons={ buttons }
        containerAlign={ containerAlign }
        subtitle={ subtitle }
        title={ title }
      />
    </div>
  </div>
);

AutopromoContentContainer.propTypes = {
  buttons: PropTypes.arrayOf(Object).isRequired,
  buttonsMobile: PropTypes.arrayOf(Object).isRequired,
  containerAlign: PropTypes.string.isRequired,
  darkFontVersion: PropTypes.bool.isRequired,
  isCenterAlign: PropTypes.bool.isRequired,
  isCenterAlignDesktop: PropTypes.bool.isRequired,
  subtitle: PropTypes.string.isRequired,
  subtitleMobile: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  titleMobile: PropTypes.string.isRequired
};

export default AutopromoContentContainer;
